import { gql } from "@apollo/client";

// Deferred companion to AssetDashboardHero: fetches the connection firmware
// version and the modem/gateway firmware version shown in the hero lead. Must
// ONLY be used with fetchPolicy 'no-cache' — the backend returns gateway objects
// with an empty id when firmwareVersion is selected, which breaks Apollo cache
// normalization (Invariant Violation on write; see the same caveat in AssetsTable).
export const AssetIoTFirmware = gql`
    query AssetIoTFirmware ($id: ID!) {
        assetLocation (id: $id) {
            id
            iotConnection {
                id
                firmwareVersion
                gateway {
                    id
                    firmwareVersion
                }
            }
        }
    }
`;
